(function () {
  var scriptEl = document.currentScript;
  var productId = scriptEl && scriptEl.getAttribute('data-product-id');
  if (!productId) return; // safety: don't run without knowing which product

  var radioId = 'purchaseTypeSubscription-' + productId;
  var WATCH_MS = 15000;
  var startTime = Date.now();
  var userInteracted = false;

  function tryCorrect() {
    if (userInteracted) return;
    var input = document.getElementById(radioId);
    if (!input || input.checked) return;
    input.click();
  }

  // Only real user clicks count — this script's own .click() calls dispatch
  // untrusted events, so they're excluded automatically.
  document.addEventListener(
    'click',
    function (e) {
      if (e.isTrusted) userInteracted = true;
    },
    true
  );

  tryCorrect();

  var observer = new MutationObserver(function () {
    if (userInteracted || Date.now() - startTime > WATCH_MS) {
      observer.disconnect();
      return;
    }
    tryCorrect();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });

  setTimeout(function () {
    observer.disconnect();
  }, WATCH_MS);
})();